import { render, staticRenderFns } from "./SectionConfigurationModal.vue?vue&type=template&id=54fdfa34&"
import script from "./SectionConfigurationModal.vue?vue&type=script&lang=js&"
export * from "./SectionConfigurationModal.vue?vue&type=script&lang=js&"
import style0 from "./SectionConfigurationModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports